import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import trackAmplitude from 'services/analytics';

export default function StaticRenderer({ pageName, quizConfig, setIsLoading }) {
  const navigate = useNavigate();
  const [DynamicComponent, setDynamicComponent] = useState(null);

  const loadPage = useCallback(async () => {
    setIsLoading(true);
    try {
      const { default: Components } = await import(`./pages/${pageName}`);

      const nextPage = quizConfig?.[pageName]?.nextPage;
      const nextCfg = quizConfig?.[nextPage];

      if (nextPage && nextCfg?.renderer === 'static') {
        try {
          import(/* webpackPrefetch: true */ `./pages/${nextPage}`);
        } catch (error) {
          console.error(error);
        }
      }

      setDynamicComponent(<Components pageName={pageName} />);
      trackAmplitude(quizConfig?.[pageName]?.eventName);
    } catch (error) {
      console.error(error);
      const startPage = quizConfig?.startPage;
      startPage && navigate(`./${startPage}`);
    } finally {
      setIsLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageName, quizConfig]);

  useEffect(() => {
    loadPage();
  }, [loadPage]);

  return DynamicComponent;
}
